import React from "react";
import { useI18n } from "../i18n";
import { Section, SectionHeading } from "./Section";
import { FAQ_IDS } from "../data/structure";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FaqSection() {
  const { d } = useI18n();
  return (
    <Section testid="faq-section">
      <SectionHeading kicker={d.faqSection.kicker} heading={d.faqSection.heading} align="center" />
      <div className="mt-12 max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQ_IDS.map((id) => {
            const f = d.faq[id];
            return (
              <AccordionItem
                key={id}
                value={id}
                data-testid={`faq-${id}`}
                className="glass rounded-xl border border-jlo-gold/20 px-5"
              >
                <AccordionTrigger className="text-left font-display text-lg text-jlo-warm hover:text-jlo-gold hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-jlo-warm/75 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </Section>
  );
}
